import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IJobTrigger } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

@Injectable()
export class JobTriggerService extends ODataService<IJobTrigger, number> {
    protected _endpoint = '/odata/JobTriggers';

    constructor(http: HttpClient) {
        super(http, MapperService.jobTriggerMap);
    }
}
